<div class="row">
  <app-form-field [label]="label" class="col col-md-5"
                  [(value)]="packaging.typeOfPackages" [editMode]="editMode"
                  [includeMargin]="false" [formatter]="refData.packageTypeFormatter"
                  [checkForErrors]="'Package type'">
    <app-search [(ngModel)]="packaging.typeOfPackages" dataKey="code" placeholder="Select package type"
                [optionsProvider]="refData.getCargoPackageTypes"
                [inputFormatter]="refData.packageTypeFormatter" required></app-search>
  </app-form-field>
  @if (!isNotPackaged()) {
    <app-form-field label="Amount" class="col col-md-2"
                    [(value)]="packaging.numberOfPackages" [editMode]="editMode"
                    [includeMargin]="false" [checkForErrors]="true">
      <input class="input-group form-control" type="number" required
             [(ngModel)]="packaging.numberOfPackages"/>
    </app-form-field>
  }
  <app-form-field label="Shipping marks" class="col col-md-4" [(value)]="packaging.shippingMarks"
                  [editMode]="editMode" [includeMargin]="false" [checkForErrors]="true">
    <app-tags [(ngModel)]="packaging.shippingMarks" placeholder="Add shipping mark" [readonly]="!editMode"
              class="input-group form-control" [required]="!isNotPackaged()"></app-tags>
  </app-form-field>
  <ng-content></ng-content>
</div>
